jQuery(document).ready(function () {
    var maxHauteur = 0;
    console.log(maxHauteur)
    $('.quattrocolumnsduo_singleColumn').each(function() {
        var hauteur = $(this).height();
        if (hauteur > maxHauteur) {
            maxHauteur = hauteur;
        }
    });
    $('.quattrocolumnsduo_singleColumn').height(maxHauteur);
});
